export const SIGNAL_R_HUB_NAME = 'datachange';

export enum SignalrEvent {
    ActivityCommentAdded = 'ActivityCommentAdded',
    BulkJobCompleted = 'BulkJobCompleted',
    CaseReady = 'CaseReady',
    CaseUpdated = 'CaseUpdated',
    DocumentGenerated = 'DocumentGenerated',
    DocumentListUpdated = 'DocumentListUpdated',
    ExportGenerated = 'ExportGenerated',
    ImportCompleted = 'ImportCompleted',
    NotificationsUpdate = 'NotificationsUpdate',
    PartyCasesUpdated = 'PartyCasesUpdated',
    PartyRoleCasesUpdated = 'PartyRoleCasesUpdated',
    PartyRoleUpdated = 'PartyRoleUpdated',
    PartyUpdated = 'PartyUpdated',
    SendAmlReportUpdated = 'SendAmlReportUpdated',
    UIReload = 'UIReload',
    WorkItemCompleted = 'WorkItemCompleted',
    VisitorEngaged = 'VisitorEngaged',
    AppUpdated = 'AppUpdated',
    ExternalTaskSubmitted = 'ExternalTaskSubmitted',
}

export const AllSignalrEvents = Object.values(SignalrEvent);
